export var getCreatedDate = function (item) {
    var _a, _b, _c, _d, _e, _f;
    if (item === void 0) { item = {}; }
    return ((_f = (_e = (_b = (_a = item.program) === null || _a === void 0 ? void 0 : _a.transitions) === null || _b === void 0 ? void 0 : _b[((_d = (_c = item.program) === null || _c === void 0 ? void 0 : _c.transitions) === null || _d === void 0 ? void 0 : _d.length) - 1]) === null || _e === void 0 ? void 0 : _e.occurredAt) !== null && _f !== void 0 ? _f : undefined);
};
